import "./bootstrap";

import { createApp, h, DefineComponent } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { createPinia } from "pinia";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";
import { i18nVue } from "laravel-vue-i18n";
import { PageProps } from "@/Types";
import * as Sentry from "@sentry/vue";
const appName = import.meta.env.VITE_APP_NAME || "Laravel";

const pinia = createPinia();

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolvePageComponent(
        `./Pages/${name}.vue`,
        import.meta.glob<DefineComponent>("./Pages/**/*.vue")
    ),
    setup({ el, App, props, plugin }) {
        const initialPageProps = <PageProps>props.initialPage.props;
        const vueApp = createApp({ render: () => h(App, props) });

        if (import.meta.env.VITE_SENTRY_VUEJS_DSN) {
            Sentry.init({
                app: vueApp,
                dsn: import.meta.env.VITE_SENTRY_VUEJS_DSN,
                tracesSampleRate: 0.5, // Capture 100% of the transactions, reduce in production!
                logErrors: true,
                autoSessionTracking: false, // default: true
                ignoreErrors: [/^Network Error$/, /^Request aborted$/], // Ignore some Axios errors
                integrations: [
                    Sentry.thirdPartyErrorFilterIntegration({
                        filterKeys: ["ixo-app-key"],
                        behaviour: "drop-error-if-contains-third-party-frames",
                    }),
                ],
            });
        }

        vueApp
            .use(plugin)
            .use(pinia)
            .use(i18nVue, {
                lang: initialPageProps.current_locale || "en",
                fallbackLang: initialPageProps.default_locale || "en",
                resolve: (lang: string) => import(`../../lang/${lang}.json`),
            })
            .use(ZiggyVue)
            .mount(el);
    },
    progress: {
        color: "#4B5563",
    },
}).then(null);
